
// src/components/TZ/patentOblRes/PatentOblResults.jsx
import React, { useState } from 'react';
import { Tabs } from 'antd';
import { useSelector } from 'react-redux';

import SearchForm from './SearchForm';
import ResultsGrid from '../ext/ResultsGrid';
import WipoResultsGrid from '../WIPO/WipoResultsGrid';

const PatentOblResults = () => {
  const { results, loading, error } = useSelector((s) => s.search);
  const { lastSearchQuery } = useSelector((s) => s.tz);
  const wipoLastSearchQuery = useSelector((s) => s.wipo.lastSearchQuery);
  const [, setLocalState] = useState({
    previewSrc: null,
    originalPreviewSrc: null,
    croppedBlob: null,
    cropConfig: null,
    fileName: null,
  });

  const items = [
    {
      key: 'patentObl',
      label: 'ТЗ',
      children: (
        <ResultsGrid
          items={results.patentObl}
          loading={loading.patentObl}
          error={error.patentObl}
          loadingTip="Поиск ТЗ по правообладателю…"
          errorTitle="Ошибка ТЗ"
          emptyTitle="ТЗ не найдены"
          requestType="По правообладателю (ТЗ)"
          searchQuery={lastSearchQuery}
        />
      )
    },
    {
      key: 'patentOblRequests',
      label: 'Заявки',
      children: (
        <ResultsGrid
          items={results.patentOblRequests}
          loading={loading.patentOblRequests}
          error={error.patentOblRequests}
          loadingTip="Поиск заявок по правообладателю…"
          errorTitle="Ошибка заявок"
          emptyTitle="Заявок не найдено"
          requestType="По правообладателю (заявки)"
          searchQuery={lastSearchQuery}
        />
      )
    },
    {
      key: 'wipo',
      label: 'WIPO',
      children: (
        <WipoResultsGrid
          items={results.wipoObl}
          loading={loading.wipoObl}
          error={error.wipoObl}
          loadingTip="Поиск WIPO по правообладателю…"
          errorTitle="Ошибка WIPO"
          emptyTitle="Не найдено"
          requestType="WIPO: Правообладатель"
          searchQuery={wipoLastSearchQuery}
        />
      )
    }
  ];

  return (
    <div style={{ width: '100%', padding: 16 }}>
      <SearchForm setLocalState={setLocalState} />
      <Tabs defaultActiveKey="patentObl" destroyInactiveTabPane={false} items={items} />
    </div>
  );
};

export default PatentOblResults;
